import { Anchor, Button, Stack, Text, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import { notifications } from '@mantine/notifications';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { sessionApi, useBrand, slugDaPorta } from '@eva/domain';
import { AuthFrame } from './AuthFrame';

export function ForgotPasswordPage() {
  const { brand, detection } = useBrand();
  const navigate = useNavigate();
  const [enviando, setEnviando] = useState(false);
  const form = useForm({
    initialValues: { email: '' },
    validate: { email: (v) => (/^\S+@\S+\.\S+$/.test(v) ? null : 'Email inválido') },
  });

  const enviar = form.onSubmit(async ({ email }) => {
    setEnviando(true);
    try {
      await sessionApi.forgotPassword(email.trim().toLowerCase(), slugDaPorta(brand, detection));
      navigate(`/redefinir-senha?email=${encodeURIComponent(email.trim().toLowerCase())}`);
    } catch (e: any) {
      notifications.show({ color: 'red', title: 'Não foi possível enviar', message: e?.message ?? 'Tente novamente.' });
    } finally {
      setEnviando(false);
    }
  });

  return (
    <AuthFrame title="Esqueceu a senha?" subtitle="Enviamos um código de 6 dígitos para o seu email.">
      <form onSubmit={enviar}>
        <Stack gap="md">
          <TextInput label="Email" placeholder="exemplo@email.com" type="email" autoComplete="email" size="md" {...form.getInputProps('email')} />
          <Button type="submit" size="md" loading={enviando} fullWidth>
            Enviar código
          </Button>
          <Text fz="sm" ta="center">
            <Anchor component={Link} to="/entrar" fz="sm">Voltar para o login</Anchor>
          </Text>
        </Stack>
      </form>
    </AuthFrame>
  );
}
